"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeSystemDesignation = void 0;
/**
 * The CodeSystem resource is used to declare the existence of and describe a code system or code system supplement and its key properties, and optionally define a part or all of its content.
 */
var CodeSystemDesignation = /** @class */ (function () {
    function CodeSystemDesignation() {
    }
    return CodeSystemDesignation;
}());
exports.CodeSystemDesignation = CodeSystemDesignation;
